import { gql, useLazyQuery } from "@apollo/client";
import { getErrors } from "../../utils";
import { AsyncQueryStatus } from "../../models/AsyncActionStatus";
import { PermitMetricQueryInput } from "./getPermitsCountByStatesMetric";

export interface MetricPermits_metricPermits_items {
  __typename: "MetricPermitRef";
  id: string;
  number: number;
  state: string | null;
  permitTypeName: string | null;
  registerId: string;
  projectName: string | null;
}

export interface MetricPermits_metricPermits {
  __typename: "MetricPermitsCollectionSegment";
  totalCount: number;
  items: MetricPermits_metricPermits_items[];
}

export interface MetricPermits {
  metricPermits: MetricPermits_metricPermits;
}

export interface MetricPermitsVariables {
  query: PermitMetricQueryInput;
  skip?: number | null;
  take?: number | null;
}

export const GET_METRIC_PERMITS = gql`
  query MetricPermits($query: PermitMetricQueryInput!, $skip: Int, $take: Int) {
    metricPermits(query: $query, skip: $skip, take: $take) {
      totalCount
      items {
        id
        number
        state
        permitTypeName
        registerId
        projectName
      }
    }
  }
`;

export function useGetMetricPermits() {
  const [getMetricPermits, { loading, error, data }] = useLazyQuery<
    MetricPermits,
    MetricPermitsVariables
  >(GET_METRIC_PERMITS, {
    errorPolicy: "all",
    fetchPolicy: "cache-and-network",
  });

  return {
    getMetricPermits,
    data,
    status: {
      loading,
      errors: getErrors(error),
      successful: !error && data ? true : false,
    } as AsyncQueryStatus,
  };
}
